import React, { useEffect, useRef, useState, useMemo, useContext } from "react";
import useCommonQuery from "../../store/common/useCommonQuery";
import {
  Box,
  InputAdornment,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useHistory } from "react-router-dom";
import { variableContext } from "../../context/VariableContex";
import useStyles from "../../SharedClass/sharedClass";
import SearchIcon from "@mui/icons-material/Search";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ConstructionIcon from "@mui/icons-material/Construction";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import HardwareIcon from "@mui/icons-material/Hardware";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import CategoreyCard from "../../components/CategoreyCard";
import LayoutToggle from "../../components/LayoutToggle/LayoutToggle";
import "../../page-header-controls.css";

const CATEGORY_ICONS = {
  "hello doctor": <LocalHospitalIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
  "public service": <AccountBalanceIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
  "heavy equipment": <ConstructionIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
  "building service": <HomeRepairServiceIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
  "building material service": <HardwareIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
  "ambulance & auto service": <AirportShuttleIcon style={{ fontSize: 14, marginRight: 6, flexShrink: 0, color: "#7ec8e3" }} />,
};

const CATEGORY_ORDER = [
  "Hello Doctor",
  "Public Service",
  "Heavy Equipment",
  "Building Service",
  "Building Material Service",
  "Ambulance & Auto Service",
];

function CategorySearch() {
  const history = useHistory();
  const classes = useStyles();
  const { layoutMode } = useContext(variableContext);
  const isGrid = layoutMode === "grid";

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [height, setHeight] = useState("");

  const inputRef = useRef();

  const query = {
    search,
    limit: 2000,
    id: "",
    offset: 0,
  };
  const { data: subcategoryList, isSuccess } =
    useCommonQuery.Get_subcategory(query);

  const { data: categoryData } =
    useCommonQuery.Get_category({ limit: 200, offset: 0 });

  const groupedSections = useMemo(() => {
    const categories = categoryData?.data?.results ?? [];
    const subcategories = subcategoryList?.data?.results ?? [];
    if (categories.length === 0 || subcategories.length === 0) return null;

    const subMap = {};
    subcategories.forEach((sub) => {
      const key = String(sub.category);
      if (!subMap[key]) subMap[key] = [];
      subMap[key].push(sub);
    });
    Object.values(subMap).forEach((arr) =>
      arr.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
    );

    const sorted = [...categories].sort((a, b) => {
      const ai = CATEGORY_ORDER.findIndex(
        (n) => n.toLowerCase() === (a.name ?? "").toLowerCase()
      );
      const bi = CATEGORY_ORDER.findIndex(
        (n) => n.toLowerCase() === (b.name ?? "").toLowerCase()
      );
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return (a.priority ?? 0) - (b.priority ?? 0);
    });

    return sorted
      .map((cat) => ({ category: cat, subcategories: subMap[String(cat.id)] ?? [] }))
      .filter((s) => s.subcategories.length > 0);
  }, [categoryData, subcategoryList]);

  const handleClick = (name) => {
    history.push(`/category/subCategory/${name}`);
  };
  // window.addEventListener("scroll", function () {
  //   setHeight(window.pageYOffset);
  // });
  // console.log({ height });

  // const onScroll = () => {
  //   const scrollTop = document.documentElement.scrollTop;
  //   const scrollHeight = document.documentElement.scrollHeight;
  //   const clientHeight = document.documentElement.clientHeight;

  //   if (
  //     scrollTop + clientHeight >= scrollHeight &&
  //     !loading &&
  //     items.length !== subcategoryList?.data?.count
  //   ) {
  //     setLoading(true);
  //     setCurrentPage((prev) => prev + 1);
  //   }
  // };
  // useEffect(() => {
  //   window.addEventListener("scroll", onScroll);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, [height]);

  useEffect(() => {}, [search]);

  // ── Theme tokens — grid = light, list = dark (unchanged) ──────────────────
  const theme = isGrid
    ? {
        pageBg:        "#f0f4f8",
        headerBg:      "#ffffff",
        headerShadow:  "0 2px 8px rgba(0,0,0,0.10)",
        headerColor:   "#1a2a3a",
        searchBg:      "#f5f7fa",
        searchBorder:  "1px solid #d0d8e4",
        searchShadow:  "0 1px 4px rgba(0,0,0,0.08)",
        searchColor:   "#1a2a3a",
        searchPH:      "rgba(80,100,120,0.55)",
        searchIcon:    "#5a7a9a",
        h4Color:       "#1a2a3a",
        countColor:    "#2e7dc4",
        sectionBg:     "#e8edf3",
        sectionBorder: "#2e7dc4",
        sectionText:   "#1a3a5c",
        sectionCount:  "#2e7dc4",
        sectionIcon:   "#2e7dc4",
        cardsBg:       "#ffffff",
        homeBg:        "linear-gradient(145deg, #e8f0fe, #d0e4ff)",
        homeBgHov:     "linear-gradient(145deg, #d0e4ff, #b8d4ff)",
        homeBorder:    "rgba(21,101,192,0.30)",
        homeShadow:    "0 1px 4px rgba(21,101,192,0.15)",
        homeColor:     "#1565C0",
      }
    : {
        pageBg:        "transparent",
        headerBg:      "linear-gradient(160deg, #0d2248 0%, #091c3e 50%, #071428 100%)",
        headerShadow:  "0 4px 18px rgba(0,0,0,0.55), inset 0 1px 0 rgba(140,210,255,0.18), inset 0 -1px 0 rgba(30,80,200,0.12)",
        headerColor:   "#c8e4ff",
        searchBg:      "linear-gradient(135deg, #1a3a6e 0%, #1565c0 60%, #42a5f5 100%)",
        searchBorder:  "1px solid rgba(100,180,255,0.55)",
        searchShadow:  "0 2px 12px rgba(0,0,0,0.35), inset 0 1px 0 rgba(180,220,255,0.25)",
        searchColor:   "#e8f4ff",
        searchPH:      "rgba(200,230,255,0.65)",
        searchIcon:    "#7ec8f8",
        h4Color:       "inherit",
        countColor:    "#7ec8e3",
        sectionBg:     "linear-gradient(90deg, #0a1a2e 0%, #0d2a4a 100%)",
        sectionBorder: "#4fc3f7",
        sectionText:   "#e0f4ff",
        sectionCount:  "#7ec8e3",
        sectionIcon:   "#7ec8e3",
        cardsBg:       "transparent",
        homeBg:        "linear-gradient(135deg, rgba(255,255,255,0.10) 0%, rgba(8,22,55,0.88) 100%)",
        homeBgHov:     "rgba(10,30,70,0.92)",
        homeBorder:    "rgba(80,160,255,0.40)",
        homeShadow:    "0 1px 6px rgba(0,0,0,0.35)",
        homeColor:     "#b8d8f8",
      };

  // Total subcategory count across all sections
  const totalCount = groupedSections
    ? groupedSections.reduce((sum, s) => sum + s.subcategories.length, 0)
    : (subcategoryList?.data?.results?.length ?? 0);

  return (
    <div
      id="parent-div"
      ref={inputRef}
      style={{ height: "100vh", overflowY: "scroll", background: theme.pageBg }}
    >
      <div
        className="clv-body"
        style={{
          background: theme.headerBg,
          boxShadow: theme.headerShadow,
          color: theme.headerColor,
          padding: "10px",
        }}
      >
        {/* ── Top row: centered title + right-side count ── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
          <div style={{ flex: 1 }} />
          <h4 style={{ margin: 0, color: theme.h4Color, textAlign: "center", flex: 2 }}>All Subcategories</h4>
          <span style={{ flex: 1, textAlign: "right", fontSize: "11px", fontWeight: "600", color: theme.countColor }}>
            {totalCount} items
          </span>
        </div>

        {/* ── Search row: [Home] [Search field] [LayoutToggle] ── */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            onClick={() => history.push("/")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              height: 40,
              padding: "0 10px",
              background: theme.homeBg,
              border: `1px solid ${theme.homeBorder}`,
              borderRadius: 8,
              boxShadow: theme.homeShadow,
              cursor: "pointer",
              flexShrink: 0,
              color: theme.homeColor,
              fontSize: 12,
              fontWeight: 600,
              whiteSpace: "nowrap",
              boxSizing: "border-box",
            }}
          >
            <HomeIcon style={{ fontSize: 15, color: theme.homeColor, flexShrink: 0 }} />
            <span style={{ fontSize: 12, fontWeight: 600, color: theme.homeColor }}>Home</span>
          </button>
          <TextField
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon style={{ color: theme.searchIcon }} />
                </InputAdornment>
              ),
            }}
            className={classes.searchBar}
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              flex: 1,
              "& .MuiInputBase-root": {
                background: theme.searchBg,
                border: theme.searchBorder,
                boxShadow: theme.searchShadow,
              },
              "& .MuiInputBase-input": {
                color: theme.searchColor,
                "&::placeholder": { color: theme.searchPH, opacity: 1 },
              },
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
          />
          <LayoutToggle size="sm" />
        </Box>
        {groupedSections
          ? groupedSections.map(({ category, subcategories }, sectionIndex) => (
              <div key={category.id}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: theme.sectionBg,
                    borderLeft: `4px solid ${theme.sectionBorder}`,
                    padding: "8px 14px",
                    marginTop: sectionIndex === 0 ? "10px" : "18px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "800",
                      fontSize: "11px",
                      color: theme.sectionText,
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    {React.cloneElement(
                      CATEGORY_ICONS[(category.name ?? "").toLowerCase()] ?? <span />,
                      { style: { fontSize: 14, marginRight: 6, flexShrink: 0, color: theme.sectionIcon } }
                    )}
                    {category.name}
                  </span>
                  <span style={{ fontSize: "10px", color: theme.sectionCount, fontWeight: "600" }}>
                    {subcategories.length} items
                  </span>
                </div>
                <Box
                  sx={isGrid ? {
                    background: "#ffffff",
                    "& .MuiCard-root": { backgroundColor: "#ffffff !important" },
                    "& .MuiTypography-root": { color: "#111111 !important" },
                  } : {}}
                >
                  <Grid container spacing={2} style={{ padding: "0.75rem 1rem" }}>
                    {subcategories.map((item) => (
                      <CategoreyCard
                        key={item.id}
                        id={item.id}
                        title={item.name}
                        handleClick={handleClick}
                        image={item.image}
                      />
                    ))}
                  </Grid>
                </Box>
              </div>
            ))
          : (
            <Grid container spacing={2} style={{ padding: "1rem" }}>
              {subcategoryList?.data?.results?.map((item, idx) => (
                <CategoreyCard
                  key={idx}
                  id={item.id}
                  title={item.name}
                  handleClick={handleClick}
                  image={item.image}
                />
              ))}
            </Grid>
          )}
      </div>
    </div>
  );
}

export default React.memo(CategorySearch);
